export default function (x) {
  return function () {
    return x;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/constant.js
// module id = 427
// module chunks = 0